import { render, staticRenderFns } from "./ViewOrganizationUserProfile.vue?vue&type=template&id=9c2b991e&scoped=true"
import script from "./ViewOrganizationUserProfile.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationUserProfile.vue?vue&type=script&lang=js"
import style0 from "./ViewOrganizationUserProfile.vue?vue&type=style&index=0&id=9c2b991e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2b991e",
  null
  
)

export default component.exports